import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.0156 4.01886L18.0687 8.15901C18.3487 8.73533 19.0953 9.28814 19.7252 9.39399L23.4465 10.0174C25.8262 10.4173 26.3861 12.158 24.6713 13.8752L21.7783 16.7922C21.2884 17.2861 21.0201 18.2389 21.1717 18.921L22 22.5319C22.6532 25.39 21.1484 26.4956 18.6403 25.0019L15.1524 22.92C14.5224 22.5437 13.4842 22.5437 12.8426 22.92L9.35469 25.0019C6.8583 26.4956 5.3418 25.3783 5.99506 22.5319L6.8233 18.921C6.97495 18.2389 6.70665 17.2861 6.2167 16.7922L3.32369 13.8752C1.62054 12.158 2.16881 10.4173 4.54855 10.0174L8.26981 9.39399C8.88807 9.28814 9.63466 8.73533 9.91462 8.15901L11.9677 4.01886C13.0876 1.77236 14.9074 1.77236 16.0156 4.01886Z",
      stroke: "#B7B7B7",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }